export const commanderDefaults = {
  raider: {
    label: "Raider",
    priorities: { scout: 1.3, defend: 2, raid: 1.8, expand: 0.8, assault: 1 },
    risk: 0.8,
    retreat: 0.65,
  },
  architect: {
    label: "Architect",
    priorities: { scout: 1.1, defend: 2.2, raid: 0.8, expand: 1.9, assault: 1 },
    risk: 0.7,
    retreat: 0.5,
  },
  breaker: {
    label: "Breaker",
    priorities: { scout: 1, defend: 2, raid: 0.9, expand: 1, assault: 1.8 },
    risk: 1.3,
    retreat: 0.35,
  },
} as const;

export const simCommandersConfig = {
  MAX_MISSION_UNITS: 150 as const,
  MAX_MISSION_BUDGET: 1e9 as const,
};

// Validation limits in packages/sim/src/commanders.ts
export const simCommandersLimits = {
  AiSeedSchema_maximum: 0xffffffff,
  integer_maximum: 1_000_000_000,
  point_x_maximum: 100_000,
  point_y_maximum: 100_000,
  AiMissionSchema_structure_maxLength: 64,
  AiMissionSchema_initialValue_maximum: 1e9,
  AiMissionSchema_initialHp_maximum: 1e9,
  AiMissionSchema_reason_maxLength: 128,
  AiBrainSchema_missions_maxItems: 3,
  AiBrainSchema_observations_team_maximum: 7,
  AiBrainSchema_observations_kind_maxLength: 64,
  AiBrainSchema_observations_hp_maximum: 1e9,
  AiBrainSchema_observations_value_maximum: 1e9,
  AiBrainSchema_observations_maxItems: 128,
  AiBrainSchema_docks_supplies_maximum: 1e9,
  AiBrainSchema_docks_maxItems: 64,
  AiBrainSchema_outcomes_lost_maximum: 1e9,
  AiBrainSchema_outcomes_maxItems: 24,
  AiBrainsSchema_minItems: 2,
  AiBrainsSchema_maxItems: 8,
};

export const aiPolicyConfig = {
  buildOffsetsX: [11, 6, 1, -4],
  buildOffsetsY: [-12, -7, -2, 3, 8],
  unloadOffsetsX: [18, 22, 26, 30],
  unloadOffsetsY: [-12, -8, -4, 0, 4, 8, 12],
  nearbySupplyDocks: 2,
  armyRotationTicks: 60,
  mobileSpeedThreshold: 80,
  productionQueueTarget: 2,
  gathererQueueMax: 5,
  grenadierEnemyInfantryFraction: 0.4,
  grenadierArmyGroupSize: 8,
  gathererRouteLength: 400,
  gathererSoftCap: 8,
  gathererReferencePopulation: 100,
  observationTtlTicks: 1800,
  observationsMax: 128,
  knownDocksMax: 64,
  outcomesMax: 24,
  dangerRadius: 420,
  failureRadius: 200,
  costPenalty: 0.15,
  failuresPenaltyMax: 3,
  failurePenalty: 250,
  distancePenalty: 0.1,
  defenseRecallFraction: 0.65,
  routeEndToleranceTiles: 4,
  defenderValueFloor: 100,
  defenseBudgetMultiplier: 1.5,
  defenseReward: 10000,
  scoutRefreshTicks: 600,
  scoutBudget: 800,
  raidTargetBonus: 1000,
  raidTargetCost: 2000,
  raidMinUnits: 2,
  raidBudget: 4000,
  raidRewardBonus: 2000,
  recentEnemyTicks: 600,
  finishingMinUnits: 3,
  assaultMinUnits: 2,
  assaultBudget: 20000,
  assaultReward: 5000,
  expansionSupportBudget: 1500,
  lowSupplyExpansionReward: 5500,
  missionsMax: 3,
  scoreTieMin: 100,
  routeDetourTolerance: 300,
  routeFailureRadius: 100,
  routeFailureCost: 10000,
  launchDelayTicks: 1800,
  assaultDeadlineTicks: 14400,
  raidSuccessHealthFraction: 0.7,
  objectiveArrivalRadius: 180,
  attackContactRadius: 250,
  raidDangerRadius: 400,
  expansionSiteRadius: 180,
  supportFollowRadius: 180,
  scoutReward: 1200,
  raidSizeDivisor: 3,
  finishingReserveUnits: 2,
  finishingRewardBonus: 2500,
  growthExpansionReward: 3400,
  expansionReward: 2000,
  scoreTieFraction: 0.15,
  missionDeadlineTicks: 7200,
};
